import type ShariffLinkGeneratorInterface from "@/ts/components/Shariff/Interfaces/ShariffLinkGeneratorInterface";
import SocialMediaEnum from "@/ts/components/Shariff/Enums/SocialMediaEnum";
import FacebookShareLinkGenerator from "@/ts/components/Shariff/LinkGenerators/FacebookShareLinkGenerator";
import TwitterLinkGenerator from "@/ts/components/Shariff/LinkGenerators/TwitterLinkGenerator";
import PinterestShareLinkGenerator from "@/ts/components/Shariff/LinkGenerators/PinterestShareLinkGenerator";
import InstagramShareLinkGenerator from "@/ts/components/Shariff/LinkGenerators/InstagramShareLinkGenerator";
import WhatsappShareLinkGenerator from "@/ts/components/Shariff/LinkGenerators/WhatsappShareLinkGenerator";

export default class ShariffLinkGeneratorFactory {
    linkGeneratorByTypeString(type: SocialMediaEnum): ShariffLinkGeneratorInterface | undefined {
        switch (type) {
        case SocialMediaEnum.FACEBOOK:
            return new FacebookShareLinkGenerator();
        case SocialMediaEnum.TWITTER:
            return new TwitterLinkGenerator();
        case SocialMediaEnum.PINTEREST:
            return new PinterestShareLinkGenerator();
        case SocialMediaEnum.INSTAGRAM:
            return new InstagramShareLinkGenerator();
        case SocialMediaEnum.WHATSAPP:
            return new WhatsappShareLinkGenerator();
        default:
            return undefined;
        }
    }
}
